export default {
  BT_HDP: "ပေါက်ကြေး",
  BT_OU: "ဂိုးပေါ် / ဂိုးအောက်",
  BT_ML: "Moneyline",
  BT_1X2: "အနိုင်အရှုံးသရေ",
  BT_1X2HDP: "၃မျိုးပေါက်‌ကြေး",
  BT_CS: "ဂိုးခန့်မှန်း",
  BT_OE: "မ/စုံ",
  BT_DC: "နှစ်ထပ်အခွင့်အရေး",
  BT_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BT_FGLG: "ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TG: "ဂိုးအရေအတွက်",
  BT_OR: "ဖလားခန့်မှန်း",
  BT_ORZ: "ဖလားခန့်မှန်း",

  BT_ANB: "အ‌ဝေးကွင်းလောင်း၍မရပါ",
  BT_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BT_CL: "ပေးဂိုးမရှိ",
  BT_DNB: "သရေလောင်း၍မရပါ",
  BT_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BT_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BT_TWTN: "ပေးဂိုးမရှိပဲ အနိုင်ရရှိသူ",

  BT_HDPF: "ပေါက်ကြေး",
  BT_OUF: "ဂိုးပေါ် / ဂိုးအောက်",
  BT_MLF: "FT. Moneyline | FT. ML",
  BT_1X2F: "အနိုင်အရှုံးသရေ",
  BT_1X2HDPF: "၃မျိုးပေါက်‌ကြေး",
  BT_CSF: "ဂိုးခန့်မှန်း",
  BT_OEF: "မ/စုံ",
  BT_DCF: "နှစ်ထပ်အခွင့်အရေး",
  BT_FGLGF: "ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TGF: "ဂိုးအရေအတွက်",

  BT_HDPH: "ပထမပိုင်းပေါက်ကြေး",
  BT_OUH: "ပထမပိုင်း ဂိုး‌ပေါင်း",
  BT_MLH: "ပထမပိုင်းအနိုင်",
  BT_1X2H: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_1X2HDPH: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BT_OEH: "ပထမပိုင်း မ/စုံ",
  BT_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BT_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",
  BT_O: "Over",
  BT_U: "Under",

  BT_HDPOU: "‌ပေါက်ကြေး & ဂိုးပေါင်း",
  BT_PARLAY: "မောင်းကစားနည်း",
  BT_FT: "ပွဲချိန်ပြည့်",
  BT_1H: "ပထမပိုင်း. ",
  BT_2H: "ဒုတိယပိုင်း. ",

  BT_FG: "ပထမသွင်းဂိုး",
  BT_LG: "နောက်ဆုံးသွင်းဂိုး",
  BT_HFG: "ပထမသွင်းဂိုး (အိမ်ရှင်)",
  BT_AFG: "ပထမသွင်းဂိုး (အ‌ဝေး)",
  BT_HLG: "နောက်ဆုံးသွင်းဂိုး (အိမ်ရှင်)",
  BT_ALG: "နောက်ဆုံးသွင်းဂိုး (အဝေး)",
  BT_NG: "ဂိုးမသွင်း",
  BT_HY: "အိမ်ရှင် Yes",
  BT_HN: "အိမ်ရှင် No",
  BT_AY: "အဝေး Yes",
  BT_AN: "အဝေး No",
  BT_H: "အိမ်ရှင်",
  BT_A: "အဝေး",
  BT_D: "သရေ",
  BT_HD_DC: "အိမ်ရှင် & သရေ",
  BT_HA_DC: "အိမ်ရှင် & အဝေး",
  BT_DA_DC: "အဝေး & သရေ",
  BT_HH: "အိမ်ရှင် ၊ အိမ်ရှင်",
  BT_HD: "အိမ်ရှင် ၊ သရေ",
  BT_HA: "အိမ်ရှင် ၊ အဝေး",
  BT_DH: "သရေ ၊ အိမ်ရှင် ",
  BT_DD: "သရေ ၊ သရေ",
  BT_DA: "သရေ ၊ အဝေး",
  BT_AH: "အ‌ဝေး ၊ အိမ်ရှင် ",
  BT_AD: "အဝေး ၊ သရေ",
  BT_AA: "အဝေး ၊ အဝေး ",

  BT_Y: "Yes",
  BT_N: "No",

  BT_LIVE: "တိုက်ရိုက်",
  BT_HT: "ပထမပိုင်း ",
  BT_DELAYED: "နောက်ကျနေသည်",
  BT_PEN: "ပင်နယ်တီ",

  BT_FT1: "ပွဲချိန်ပြည့် 1 ",
  BT_FT2: "ပွဲချိန်ပြည့် 2",
  BT_FTX: "ပွဲချိန်ပြည့် x",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "နှစ်ဖက်စလုံး",
  BT_ONE: "တစ်",

  BS_HDP: "ပွဲချိန်ပြည့်ပေါက်ကြေး",
  BS_HDPH: "ပထမပိုင်း ပေါက်ကြေး",
  BS_OU: "ပွဲချိန်ပြည့် ဂိုးပေါင်း",
  BS_OUH: "ပထမပိုင်း ဂိုးပေါင်း",
  BS_OE: "ပွဲချိန်ပြည့် မ/စုံ",
  BS_OEH: "ပထမပိုင်း မ/စုံ",
  BS_1X2: "ပွဲချိန်ပြည့် 1x2",
  BS_1X2H: "ပထမပိုင်း 1x2",
  BS_ML: "ပွဲချိန်ပြည့် Moneyline",
  BS_MLH: "ပထမပိုင်း Moneyline",
  BS_1X2HDP: "ပွဲချိန်ပြည့် ၃ မျိုးပေါက်‌ကြေး",
  BS_1X2HDPH: "ပထမပိုင်း ၃ မျိုးပေါက်ကြေး",
  BS_CS: "ပွဲချိန်ပြည့် ဂိုးခန့်မှန်း",
  BS_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BS_DC: "ပွဲချိန်ပြည့် နှစ်ထပ်အခွင့်အရေး",
  BS_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BS_FGLG: "ပွဲချိန်ပြည့် ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_TG: "ပွဲချိန်ပြည့် ဂိုးအရေအတွက်",
  BS_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",
  BS_ANB: "အဝေးကွင်း လောင်း၍မရပါ",
  BS_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BS_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BS_CL: "ပေးဂိုးမရှိ",
  BS_DNB: "သရေလောင်း၍မရပါ",
  BS_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BS_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BS_TWTN: "ပေးဂိုးမရှိအနိုင်",
  BS_OR: "ဖလားခန့်မှန်း",
  BS_ORZ: "ဖလားခန့်မှန်း",
  
  LOT_BS: "အကြီး ၊ အသေး",
  LOT_BIG: "အကြီး",
  LOT_SMALL: "အသေး",
  LOT_OE: "မ/စုံ",
  LOT_ODD: "မ",
  LOT_EVEN: "စုံ",
  LOT_OU: "ဂိုးပေါ်/ဂိုးအောက်",
  LOT_OVER: "ဂိုးပေါ်",
  LOT_UNDER: "ဂိုးအောက်",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  ROOM_A: "Open",
  ROOM_0: "Active",
  ROOM_1: "Closed",
  ROOM_2: "Cancel",
  ROOM_3: "Ended",
  ROOM_4: "Stop Betting",
  ROOM_10: "All",

  ROOM_T0: "All",
  ROOM_T1: "Public Room",
  ROOM_T2: "Private Room",
  ROOM_T3: "Play to Earn",

  joinRoom1: "Join Public Room",
  joinRoom2: "Join Private Room",
  joinRoom3: "Join Play Room",
  createRoom1: "Create Public Room",
  createRoom2: "Create Private Room",
  createRoom3: "Create Play Room",
  Champion: "Champion",
  FirstRunnerUp: "First Runner Up",
  SecondRunnerUp: "Second Runner Up",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",
  
  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",
};